import axios from "axios"
import { baseUrlPostGres } from "../constant"
import HandleError from "../HandleError"
import { apiHeader } from "./ApiHeader"
import { IS_LOADING, SETTINGS_LIST_SUCCESS, SETTINGS_LIST_ERROR, SETTINGS_UPDATE_SUCCESS, SETTINGS_UPDATE_ERROR } from "./Type"
import { apiVersion } from "src/utils/apiVersion"

export const SettingsListAction = () => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .get(`${baseUrlPostGres()}/admin/${apiVersion.v1}/setting/view`, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: SETTINGS_LIST_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: SETTINGS_LIST_ERROR,
                payload: errors
            })
        })
}

export const ResetSettingsListAction = () => async (dispatch) => {
    dispatch({
        type: SETTINGS_LIST_SUCCESS,
        payload: {}
    })
}

export const UpdateSettingsAction = (data) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/setting/create`, data, {
            headers: apiHeader()
        })
        .then((response) => {
            dispatch({
                type: SETTINGS_UPDATE_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: SETTINGS_UPDATE_ERROR,
                payload: errors
            })
        })
}

export const ResetUpdateSettingsAction = () => async (dispatch) => {
    dispatch({
        type: SETTINGS_UPDATE_SUCCESS,
        payload: {}
    })
}